import { IS_MOCK } from '../lib/api';
import { GuildSelector } from './GuildSelector';
import { useAtomValue } from 'jotai';
import { guildsAtom, selGuildAtom } from '../atoms/guild';
import { GuildAvatar } from './GuildSelector';

export function Topbar() {
  const guilds  = useAtomValue(guildsAtom);
  const selId   = useAtomValue(selGuildAtom);
  const guild   = guilds.find(g => g.id === selId);

  return (
    <header
      className="h-14 shrink-0 flex items-center px-4 gap-4 border-b border-white/[0.04]"
      style={{ background: 'rgba(7,9,16,0.95)', backdropFilter: 'blur(12px)' }}
    >
      {/* Left — server avatar + name */}
      <div className="flex items-center gap-2.5 min-w-0">
        {guild ? (
          <>
            <GuildAvatar guild={guild} size={7} />
            <div className="flex flex-col leading-none min-w-0">
              <span className="text-[11px] font-black text-white truncate">{guild.name}</span>
              <span className="text-[8px] font-mono text-slate-600 tracking-wider mt-0.5">ACTIVE SERVER</span>
            </div>
          </>
        ) : (
          <div className="flex items-center gap-2 text-[10px] font-mono text-slate-600 uppercase tracking-[0.18em]">
            <i className="fa-solid fa-shield-halved text-[9px] text-cyberGreen/50" />
            Owner Panel
          </div>
        )}
      </div>

      {/* Center — server selector */}
      <div className="flex-1 flex justify-center">
        <GuildSelector />
      </div>

      {/* Right — status badges */}
      <div className="flex items-center gap-3">
        {IS_MOCK && (
          <span className="px-2 py-0.5 rounded-md bg-amber-500/10 border border-amber-500/20 text-[9px] font-mono font-bold text-amber-400 tracking-widest uppercase">
            Mock
          </span>
        )}
        <div className="flex items-center gap-1.5 text-[9px] font-mono text-slate-500">
          <span className="relative flex h-1.5 w-1.5">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-cyberGreen opacity-75" />
            <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-cyberGreen" />
          </span>
          NODE SECURE
        </div>
      </div>
    </header>
  );
}
